module.exports = __webpack_public_path__ + "img/yanzhengma1.8ed74899.png";